import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21887502"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-center" }
const _hoisted_2 = { class: "report-center-toolbar" }
const _hoisted_3 = { class: "report-search-bar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "report-search-bar-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "11",
      cy: "11",
      r: "7",
      stroke: "currentColor",
      "stroke-width": "2"
    }),
    /*#__PURE__*/_createElementVNode("line", {
      x1: "21",
      y1: "21",
      x2: "16.65",
      y2: "16.65",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_5 = { class: "report-center-grid" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "report-section-header" }
const _hoisted_8 = { class: "report-section-title" }
const _hoisted_9 = { class: "report-section-body" }
const _hoisted_10 = {
  key: 0,
  class: "report-section-empty"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "fas fa-info-circle text-primary font-size-sm ms-2" }
const _hoisted_13 = {
  key: 0,
  class: "report-center-no-results"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          class: "report-search-bar-input",
          type: "text",
          placeholder: "Search reports by name...",
          "aria-label": "Search reports by name"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.search]
        ]),
        (_ctx.search)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "report-search-bar-clear",
              "aria-label": "Clear search",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = ''))
            }, " × "))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSections, (section) => {
        return (_openBlock(), _createElementBlock("section", {
          key: section.title,
          class: "report-section",
          "aria-label": section.title
        }, [
          _createElementVNode("header", _hoisted_7, [
            _createElementVNode("h2", _hoisted_8, _toDisplayString(section.title), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (section.reports.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, " No reports match your search. "))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.reports, (report) => {
              return (_openBlock(), _createElementBlock("div", {
                key: report.name,
                class: "report-row"
              }, [
                _createElementVNode("a", {
                  class: "report-row-title",
                  href: "javascript:void(0)",
                  onClick: ($event: any) => (_ctx.openReport(report.path))
                }, _toDisplayString(report.name), 9 /* TEXT, PROPS */, _hoisted_11),
                _withDirectives(_createElementVNode("i", _hoisted_12, null, 512 /* NEED_PATCH */), [
                  [_directive_tooltip, { title: _ctx.getReportTooltip(report), placement: 'top' }]
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 8 /* PROPS */, _hoisted_6))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    (_ctx.filteredSections.every((s) => s.reports.length === 0) && _ctx.search)
      ? (_openBlock(), _createElementBlock("p", _hoisted_13, " No reports found for \"" + _toDisplayString(_ctx.search) + "\". ", 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}